import { render, staticRenderFns } from "./foodunitdetails.vue?vue&type=template&id=c540d87a"
import script from "./foodunitdetails.vue?vue&type=script&lang=js"
export * from "./foodunitdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports